function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#87E6E5",
  d: "M11.414 12c.347 0 .586.506.586 1.378v4.117l-5.565 5.889a1.649 1.649 0 000 2.232L12 31.505v4.117c0 .872-.24 1.378-.586 1.378-.141 0-.3-.084-.469-.262L.435 25.616a1.649 1.649 0 010-2.232l10.51-11.122c.168-.178.328-.262.469-.262zm25.172 0c.141 0 .3.084.469.262l10.51 11.122c.58.614.58 1.618 0 2.232l-10.51 11.122c-.168.178-.328.262-.469.262-.347 0-.586-.506-.586-1.378v-4.117l5.565-5.889c.58-.614.58-1.618 0-2.232L36 17.495v-4.117c0-.872.24-1.378.586-1.378z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 35.57,
  height: 4,
  x: 5.009,
  y: 22.662,
  fill: "#A0DB77",
  rx: 2,
  transform: "rotate(-75 22.794 24.662)"
}));

var SvgCodeBrackets = function SvgCodeBrackets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgCodeBrackets;